/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 vangard3.glb 
*/

import React from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/vangard3.glb");
	return (
		<group {...props} dispose={null}>
			<group
				position={[209, 39, 17.2]}
				rotation={[Math.PI / 2, 0, 1.5]}
				scale={0.007}
			>
				<mesh
					geometry={nodes.Mesh_1002.geometry}
					material={materials["Velvet texture.009"]}
				/>
				<mesh
					geometry={nodes.Mesh_1002_1.geometry}
					material={materials["shirts_FRONT_1828.005"]}
				/>
				<mesh
					geometry={nodes.Mesh_1002_2.geometry}
					material={materials["Material.036"]}
				/>
				<mesh
					geometry={nodes.Mesh_1002_3.geometry}
					material={materials["Material.037"]}
				/>
				<mesh
					geometry={nodes.Mesh_1002_4.geometry}
					material={materials["Material.038"]}
				/>
				<mesh
					geometry={nodes.Mesh_1002_5.geometry}
					material={materials["Material.039"]}
				/>
				<mesh
					geometry={nodes.Mesh_1002_6.geometry}
					material={materials["Material.040"]}
				/>
			</group>
		</group>
	);
}

useGLTF.preload("models/vangard3.glb");
